export default __webpack_public_path__ + "static/media/About Page.7be12141.jpg";